import { Input } from "@/components/ui/input";

const iso = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

export function periodRange(key) {
  const now = new Date();
  const today = iso(now);
  switch (key) {
    case "today":
      return [today, today];
    case "week": {
      const d = new Date(now);
      d.setDate(d.getDate() - ((d.getDay() + 6) % 7)); // Monday
      return [iso(d), today];
    }
    case "7d": {
      const d = new Date(now);
      d.setDate(d.getDate() - 6);
      return [iso(d), today];
    }
    case "month":
      return [`${today.slice(0, 7)}-01`, today];
    case "30d": {
      const d = new Date(now);
      d.setDate(d.getDate() - 29);
      return [iso(d), today];
    }
    case "year":
      return [`${now.getFullYear()}-01-01`, today];
    default:
      return ["", ""];
  }
}

const PRESETS = [
  ["all", "All time"],
  ["today", "Today"],
  ["week", "This week"],
  ["month", "This month"],
  ["year", "This year"],
  ["7d", "Last 7d"],
  ["30d", "Last 30d"],
];

export default function PeriodFilter({ dateFrom, dateTo, onChange, testId = "period-filter" }) {
  const active = PRESETS.find(([k]) => {
    const [f, t] = periodRange(k);
    return f === (dateFrom || "") && t === (dateTo || "");
  })?.[0];

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      <div className="flex flex-wrap items-center gap-1 rounded-md border border-border bg-card p-1">
        {PRESETS.map(([k, label]) => (
          <button
            key={k}
            onClick={() => {
              const [f, t] = periodRange(k);
              onChange(f, t);
            }}
            data-testid={`${testId}-${k}`}
            className={`rounded px-2.5 py-1.5 text-xs font-medium transition-colors ${
              active === k ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <Input type="date" value={dateFrom} onChange={(e) => onChange(e.target.value, dateTo)} className="w-[140px]" data-testid={`${testId}-from`} />
        <span className="text-muted-foreground">–</span>
        <Input type="date" value={dateTo} onChange={(e) => onChange(dateFrom, e.target.value)} className="w-[140px]" data-testid={`${testId}-to`} />
      </div>
    </div>
  );
}
